import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-page-filegoogle',
  templateUrl: './page-filegoogle.component.html',
  styleUrls: ['./page-filegoogle.component.css']
})
export class PageFilegoogleComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
